var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-tour"},_vm._l((_vm.tours),function(tour){return _c('v-tour',{key:tour.name,attrs:{"name":tour.name,"steps":tour.steps,"callbacks":_vm.handleCallbacks}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }